var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "current",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.293 9.29297L12 13.586L7.70703 9.29297L6.29303 10.707L12 16.414L17.707 10.707L16.293 9.29297Z",
    fill: "url(#paint0_linear_1582_4142)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1582_4142",
    x1: 6.45609,
    y1: 9.66385,
    x2: 9.13486,
    y2: 18.6676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E2DE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A00E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A00E0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.7f1c09c7c1c5712735f8a6270f8a6a9c.svg";
export { ForwardRef as ReactComponent };